import { useRouter } from 'expo-router';
import SegmentedTabs from '@/components/General/SegmentedTabs';

/**
 * FollowUpNavTabs — in-module navigation shared by the Follow Up surfaces
 * (spec §6.1): Overview (default landing), My Follow Up, People, Paths, and
 * the manage-only Audiences page. Peer tabs replace so module nav doesn't
 * stack; Audiences pushes so back returns to the surface it came from.
 */
const FollowUpNavTabs = ({ active = 'overview', canManage = false }) => {
    const router = useRouter();

    const tabs = [
        { key: 'overview', label: 'Overview', route: '/follow-up', peer: true },
        { key: 'my', label: 'My Follow Up', route: '/follow-up/my', peer: true },
        { key: 'people', label: 'People', route: '/follow-up/people', peer: true },
        { key: 'paths', label: 'Paths', route: '/follow-up/paths', peer: true },
    ];
    if (canManage) {
        tabs.push({ key: 'audiences', label: 'Audiences', route: '/follow-up/audiences', peer: false });
    }

    return (
        <SegmentedTabs
            tabs={tabs}
            value={active}
            testIDPrefix="follow-up-tab"
            onChange={(key) => {
                const tab = tabs.find((t) => t.key === key);
                if (!tab || tab.key === active) return;
                if (tab.peer) {
                    router.replace(tab.route);
                } else {
                    router.push(tab.route);
                }
            }}
        />
    );
};

export default FollowUpNavTabs;
